<template>
  <div>
    <vx-card class="mb-4">
      <div class="w-full flex flex-no-wrap">
        <div class="w-3/5">
          <h5 class="mb-4">Submerchant</h5>
            <div class="table-row w-full">
              <div class="table-cell w-2/5 p-4">
                Parent Merchant Name<span class="text-danger">*</span>
              </div>
              <div class="table-cell w-3/5 p-4">
                <vue-simple-suggest
                  pattern="\w+"
                  v-model="model"
                  :list="getList"
                  :max-suggestions="1000"
                  :min-length="0"
                  :debounce="200"
                  :filter-by-query="false"
                  :prevent-submit="true"
                  :controls="{
                    selectionUp: [38, 33],
                    selectionDown: [40, 34],
                    select: [13, 36],
                    hideList: [27, 35]
                  }"
                  :mode="mode"
                  :nullable-select="true"
                  ref="suggestComponent"
                  placeholder="Search information..."
                  value-attribute="id"
                  display-attribute="text"
                  @select="onSuggestSelect"
                >
                  <div class="g">
                    <input id="merchant-search" type="text" placeholder="Select merchant">
                  </div>

                  <template slot="misc-item-above" slot-scope="{ suggestions, query }">
                    <div class="misc-item">
                      <span>You're searching for '{{ query }}'.</span>
                    </div>

                    <template v-if="suggestions.length > 0">
                      <div class="misc-item">
                        <span>{{ suggestions.length }} suggestions are shown...</span>
                      </div>
                      <hr>
                    </template>

                    <div class="misc-item" v-else-if="!loading">
                      <span>No results</span>
                    </div>
                  </template>

                  <div slot="suggestion-item" slot-scope="scope" :title="scope.suggestion.description">
                    <div class="text">
                      <span v-html="boldenSuggestion(scope)"></span>
                    </div>
                  </div>

                  <div class="misc-item" slot="misc-item-below" v-if="loading">
                    <span>Loading...</span>
                  </div>
                </vue-simple-suggest>
                <span class="text-danger text-sm" v-show="errors.has('merchantInfo.parent')">{{ errors.first('parent merchant name') }}</span>
              </div>
            </div>

            <div class="table-row w-full mb-5">
              <div class="table-cell w-2/5 p-4">
                Submerchant Name<span class="text-danger">*</span>
              </div>
              <div class="table-cell w-3/5 p-4">
                <vs-input
                  id="txt-submerchant-name"
                  type="text"
                  placeholder="Submerchant Name"
                  v-model="merchantInfo.name"
                  class="w-full mb-4 no-icon-border"
                  name="submerchant name"
                  v-validate="'required'"
                  data-vv-validate-on="blur"
                />
                  <span class="text-danger text-sm">{{ errors.first('submerchant name') }}</span>
              </div>
            </div>
            <div class="table-row w-full mb-5">
                <div class="table-cell w-2/5 p-4">
                  Business Entity ID
                  <span class="text-danger">*</span>
                </div>
                <div class="table-cell w-3/5 p-4">
                    <vs-input
                      type="text"
                      placeholder="Business Entity ID"
                      v-model="merchantInfo.business_entity_id"
                      class="w-full mb-4 no-icon-border"
                      name="business_entity_id"
                    />
                    <span class="text-danger text-sm"></span>
                </div>
            </div>
            <div class="table-row w-full">
              <div class="table-cell w-2/5 p-4">
                Address<span class="text-danger">*</span>
              </div>
              <div class="table-cell w-3/5 p-4">
                <vs-input
                  id="txt-address"
                  type="text"
                  placeholder="Address"
                  v-model="merchantInfo.address"
                  class="w-full mb-4 no-icon-border"
                  name="address"
                  v-validate="'required'"
                  data-vv-validate-on="blur"
                />
                <span class="text-danger text-sm">{{ errors.first('address') }}</span>
              </div>
            </div>

            <div class="table-row w-full">
              <div class="table-cell w-2/5 p-4">
                Email Address
                <span class="text-danger">*</span>
              </div>
              <div class="table-cell w-3/5 p-4">
                <vs-input
                  id="txt-email-address"
                  type="text"
                  placeholder="Emaill Address"
                  v-model="merchantInfo.email"
                  class="w-full mb-4 no-icon-border"
                  name="email address"
                  v-validate="'required'"
                  data-vv-validate-on="blur"
                />
                <span class="text-danger text-sm">{{ errors.first('email address') }}</span>
              </div>
            </div>

            <div class="table-row w-full">
              <div class="table-cell w-2/5 p-4">
                Phone Number<span class="text-danger">*</span>
              </div>
              <div class="table-cell w-3/5 p-4">
                <vs-input
                  id="txt-phone-number"
                  type="text"
                  v-validate="'required|numeric|min:6|max:13'"
                  name="phone number"
                  placeholder="Phone Number"
                  v-model="merchantInfo.phoneNumber"
                  class="w-full mb-4 no-icon-border"
                />
                <span class="text-danger text-sm">{{ errors.first('phone number') }}</span>
              </div>
            </div>

            <div class="table-row w-full">
              <div class="table-cell w-2/5 p-4">
                Password<span class="text-danger">*</span>
              </div>
              <div class="table-cell w-3/5 p-4">
                <vs-input
                  id="txt-password"
                  ref="password"
                  type="password"
                  data-vv-validate-on="blur"
                  v-validate="'required|min:8|verify_password'"
                  name="password"
                  placeholder="Create Password"
                  v-model="merchantInfo.password"
                  class="w-full mb-4 no-icon-border"
                />
                <span class="text-danger text-sm">{{ errors.first('password') }}</span>
              </div>
            </div>

            <div class="table-row w-full">
              <div class="table-cell w-2/5 p-4">
                Confirm Password<span class="text-danger">*</span>
              </div>
              <div class="table-cell w-3/5 p-4">
                <vs-input
                  id="txt-confirm-password"
                  type="password"
                  v-validate="'min:8|confirmed:password'"
                  data-vv-validate-on="blur"
                  data-vv-as="password"
                  name="confirm password"
                  placeholder="Confirm Password"
                  v-model="merchantInfo.confirmPassword"
                  class="w-full mb-4 no-icon-border"
                />
                <span class="text-danger text-sm">{{ errors.first('confirm password') }}</span>
              </div>
            </div>

            <div class="table-row w-full">
                <div class="table-cell w-2/5 p-4">
                  Merchant has consolidation file?
                </div>
                <div class="table-cell w-3/5 p-4">
                    <ul class="demo-alignment">
                        <li>
                            <vs-radio id="rdo-has-fk-yes" v-model="merchantHasFk" vs-value="yesfk" >yes</vs-radio>
                        </li>
                        <li>
                            <vs-radio id="rdo-has-fk-no" v-model="merchantHasFk" vs-value="nofk" >no</vs-radio>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="table-row w-full" v-if="showMerchantConsolidationConfigs">
                <div class="table-cell w-2/5 p-4">
                    Max time sending consolidation file
                </div>
                <div class="table-cell w-3/5 p-4">
                    <flat-pickr :config="configConsolidationProcessTime" v-model="consolidationProcessTime" placeholder="Max time"/>
                </div>
            </div>

            <div class="table-row w-full" v-if="showMerchantConsolidationConfigs">
                <div class="table-cell w-2/5 p-4">
                    Consolidation emails notification
                </div>
                <div class="table-cell w-3/5 p-4">
                    <div class="flex flex-no-wrap">
                        <vs-input 
                            type="text" 
                            v-model="consolidationEmailTemp" 
                            placeholder="Email notification" 
                            class="w-full mb-4 no-icon-border"
                            maxLength=50 
                        />
                        <vs-button
                            id="btn-add-consolidation-email"
                            style="margin-left: 5px;"
                            class="w-1/5 mb-4"
                            icon-pack="feather"
                            icon="icon-plus"
                            @click="addConsolidationEmail"
                        ></vs-button>
                    </div>
                </div>
            </div>

            <div class="table-row w-full" v-if="showMerchantConsolidationConfigs === true && merchantConsolidationEmails.length > 0">
                <div class="table-cell w-2/5 px-3">
                    &nbsp;
                </div>
                <div class="table-cell w-3/5 px-3">
                    <div class="px-4 py-2"><h5 style="font-weight:700;color:#636363;">Email added</h5></div>
                    <div class="w-full flex flex-wrap" :key="ind" v-for="(data, ind) in merchantConsolidationEmails">
                        <div class="w-full px-2 py-2 flex flex-wrap">
                            <div class="w-4/5 px-3 py-2" style="word-break: break-word;">{{data}}</div>
                            <div class="w-1/5 py-2" style="text-align: center;">
                                <feather-icon
                                    icon="Trash2Icon"
                                    svgClasses="h-5 w-5"
                                    class="cursor-hand"
                                    @click="deleteConsolidationEmail(ind)"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <div class="hidden sm:hidden md:hidden lg:block lg:w-2/5 mx-auto self-center">
          <img class="w-1/2 mx-auto" src="@/assets/images/pages/graphic-4.png" alt="login"/>
        </div>
      </div>
      <div class="w-1/2 text-right">
          <span class="text-danger">* required field</span>
      </div>
    </vx-card>
    <vx-card>
      <div class="w-full text-right">
        <vs-button id="btn-cancel" type="border" @click="cancelAction">Cancel</vs-button>
        <vs-button id="btn-submit" class="ml-4" @click="submitRequest">Submit</vs-button>
      </div>
    </vx-card>
  </div>
</template>

<script>
  import MerchantAPI from "@/network/api/MerchantAPI"
  import Axios from "@/global/AxiosCall";
  import VueSimpleSuggest from 'vue-simple-suggest';
  import 'vue-simple-suggest/dist/styles.css'
  import {url} from "@/configs/apiUrl";
  import flatPickr from 'vue-flatpickr-component';
  import 'flatpickr/dist/flatpickr.css';

  export default {
    components: {
      VueSimpleSuggest,
      flatPickr,
    },
    data() {
      return {
        chosen: '',
        selected: null,
        model: null,
        mode: 'input',
        loading: false,
        log: [],
        urlx: null,
        merchantInfo: {
          id            : '',
          name          : "",
          business_entity_id : "",
          email         : "",
          address       : "",
          password      : "",
          confirmPassword: "",
          phoneNumber   : "",
          parent        : "",
          config        : {},
        },
        merchants: [],
        merchantHasFk: "nofk",
        showMerchantConsolidationConfigs: false,
        configConsolidationProcessTime: {
            noCalendar: true,
            enableTime: true,
            enableSeconds: true,
            dateFormat: 'H:i:S',
            time_24hr: true,
        },
        consolidationProcessTime: null,
        consolidationEmailTemp: "",
        merchantConsolidationEmails: [],
      }
    },

    computed: {
      validateForm() {
        return (
          !this.errors.any() &&
          this.merchantInfo.name != "" &&
          this.merchantInfo.email != "" &&
          this.merchantInfo.address != "" &&
          this.merchantInfo.password !== "" &&
          this.merchantInfo.confirmPassword !== ""
        );
      }
    },

    methods: {
      openLoading() {
        this.$vs.loading({
          type: "default"
        });
      },
      cancelAction() {
        this.$router.push({name: 'merchantManagement'});
      },
      validateMerchantRole() {
        const role = localStorage.getItem("userRole")
        return role == 'merchant_admin'
      },
      
      submitRequest() {
        let parent_id = 0
        if (this.selected !== "" && this.selected !== null) {
          if (typeof this.selected.merchant_id!=="undefined") {
            parent_id = this.selected.merchant_id
          }
        } else {
          this.$vs.notify({
            title: "Warning",
            text: "Please input all required fields!",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "warning",
            position: "top-right"
          });
          return false;
        }

        if (!this.validateForm) {
          this.$vs.notify({
            title: "Warning",
            text: "Please input all required fields!",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "warning",
            position: "top-right"
          });
          return false;
        }

        if (this.merchantHasFk === "yesfk" && this.consolidationProcessTime === null) {
          this.$vs.notify({
            title: "Warning",
            text: "Please input consolidation process time field!",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "warning",
            position: "top-right"
          });
          return false;
        }

        if (this.merchantHasFk === "yesfk" && this.merchantConsolidationEmails.length <= 0) {
          this.$vs.notify({
            title: "Warning",
            text: "Please input consolidation emails field!",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "warning",
            position: "top-right"
          });
          return false;
        }

        let config = {}
        config.merchant_has_fk  = (this.merchantHasFk === "yesfk") ? true : false
        config.consolidation_process_time = (this.merchantHasFk === "yesfk") ? this.consolidationProcessTime : ""
        config.merchant_consolidation_emails = (this.merchantHasFk === "yesfk") ? this.merchantConsolidationEmails : []

        let payload = {
          merchantInfo: {
            full_name   : this.merchantInfo.name,
            business_entity_id   : this.merchantInfo.business_entity_id,
            brand_name  : '-',
            category_id : this.merchantInfo.parent.category_id,
            email       : this.merchantInfo.email,
            status      : "pending",
            password    : this.merchantInfo.password,
            phone       : this.merchantInfo.phoneNumber,
            parent_id   : parent_id,
            details     : {address: this.merchantInfo.address,},
            config      : config,
            user_action : JSON.parse(localStorage.getItem('userInfo')).displayName
          },
          notify        : this.$vs.notify
        }

        this.openLoading()
        MerchantAPI.Save(payload).then(() => {
          payload.merchantInfo.password = "******"
          this.$store.dispatch('createAuditTrail', {
            user_id:    JSON.parse(localStorage.getItem('userInfo')).id,
            session_id: parseInt(localStorage.getItem('sessID')),
            user_name:  JSON.parse(localStorage.getItem('userInfo')).displayName,
            menu:      "Merchant Management",
            activity: "Add Submerchant",
            data_before: {},
            data_after: payload,
          })
          this.$vs.notify({
            title     : "Info",
            text      : "Add Submerchant succesfuly!",
            iconPack  : "feather",
            icon      : "icon-check-square",
            color     : "success",
            position  : "top-right"
          });

          this.$router.push({name: 'merchantManagement'})
        })
      },
      boldenSuggestion(scope) {
        if (!scope) return scope;
        if (scope.query=='') {
          this.selected = null
        } 
        const {suggestion, query} = scope;
        let result = this.$refs.suggestComponent.displayProperty(suggestion);
        if (!query) return result;
        const texts = query.split(/[\s-_/\\|.]/gm).filter(t => !!t) || [''];
        return result.replace(new RegExp('(.*?)(' + texts.join('|') + ')(.*?)', 'gi'), '$1<b>$2</b>$3');
      },
      getList() {
        let merchant = JSON.parse(localStorage.getItem("userInfo")).merchant;
        let merchantid =  ((merchant.id !== undefined )?merchant.id:((merchant.parent_id !== undefined) ? merchant.parent_id:""))
        let url = this.urlx.svd.merchant.list_by_parent_id+"/"+merchantid
        if (this.model !== null) url += "?search_merchant=" + this.model

        return new Promise((resolve, reject) => {
          Axios.Get(url).then(response => {
            if (response.code !== 200) {
              reject()
            }
            let result = []
            let i = 1
            for(let data of response.data) {
              data.merchant_id = data.id
              data.id = i + 1
              let depth = "- "
              data.name = depth.repeat(data.depth)+data.full_name
              data.text = depth.repeat(data.depth)+data.full_name
              data.code = data.code
              i++
              result.push(data)
            }
            resolve(result)
          }).catch(e => {
            this.loading = false
            reject(e)
          })
        })
      },
      onSuggestSelect(suggest) {
        this.selected = suggest
      },
      addConsolidationEmail() {
          if (this.consolidationEmailTemp.length === 0) {
              this.$vs.notify({
                  title: "Warning",
                  text: "Consolidation email must be fill!",
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "warning",
                  position: "top-right"
              });
              return false
          }
          let regexEmail = /\S+@\S+\.\S+/;
          if (!regexEmail.test(this.consolidationEmailTemp)) {
              this.$vs.notify({
                  title: "Warning",
                  text: "Email format not valid!",
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "warning",
                  position: "top-right"
              });
              return false
          }
          if (this.merchantConsolidationEmails.includes(this.consolidationEmailTemp)){
              this.$vs.notify({
                  title: "Warning",
                  text: "Consolidation email already exist, please insert other email!",
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "warning",
                  position: "top-right"
              });
              return false
          }
          if (this.merchantConsolidationEmails.length >= 5) {
                this.$vs.notify({
                  title: "Warning",
                  text: "Max 5 consolidation emails!",
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "warning",
                  position: "top-right"
              });
              return false
          }
          this.merchantConsolidationEmails.push(this.consolidationEmailTemp)
          this.consolidationEmailTemp = ""
      },
      deleteConsolidationEmail(index) {
          this.merchantConsolidationEmails.splice(index, 1)
      },
    },
    watch: {
      merchantHasFk: function(val) {
          if (val === "yesfk") {
              this.showMerchantConsolidationConfigs = true
          } else {
              this.showMerchantConsolidationConfigs = false
          }
      }
    },
    mounted() {
      this.urlx = url
      if (!this.validateMerchantRole()) {
        MerchantAPI.ListMerchantOptions().then((result) => {
          this.merchants = result.data
        })
      } else {
        let merchant = JSON.parse(localStorage.getItem("userInfo")).merchant
        this.merchants = [merchant]
        this.merchantInfo.parent = merchant
      }
    }
  }
</script>

<style lang="scss">
  .m-right-download {
    margin-right: -39px;
  }

  .vue-simple-suggest.designed .suggestions {
    position: absolute;
    left: 0;
    right: 0;
    top: 100%;
    top: calc(100% + 5px);
    border-radius: 3px;
    border: 1px solid #aaa;
    background-color: #fff;
    opacity: 1;
    z-index: 1000;
    overflow: scroll;
    height: 300px;
  }

  .flatpickr-input {
    padding: .7rem;
    font-size: 1rem;
    border-radius: 5px;
    border: 1px solid rgba(0, 0, 0, 0.2);
    color: #626262;
    width: 100%;
  }
</style>



